import { render, staticRenderFns } from "./ops_desk_public_form.vue?vue&type=template&id=5bb0647a&scoped=true&"
import script from "./ops_desk_public_form.vue?vue&type=script&lang=js&"
export * from "./ops_desk_public_form.vue?vue&type=script&lang=js&"
import style0 from "./ops_desk_public_form.vue?vue&type=style&index=0&id=5bb0647a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0647a",
  null
  
)

export default component.exports